{
	"features/pdf-generation": {
		"fallObservationDetails": {
			"causes": {
				"label": "Causes"
			},
			"consequences": {
				"label": "Conséquences"
			},
			"contexts": {
				"label": "Contexte"
			},
			"correctiveActions": {
				"label": "Actions correctives"
			},
			"location": {
				"label": "Endroit"
			},
			"notes": {
				"label": "Remarques"
			},
			"observedOn": {
				"label": "Moment de l'observation"
			},
			"occurredOn": {
				"label": "Moment de l'événement"
			},
			"title": "Détails"
		},
		"footer": {
			"export": "Exporté par {{user}} le {{exportDate}} à {{exportTime}}",
			"numbered": "Page {{page}} sur {{total}}"
		},
		"header": {
			"title": "Constatation et suivi de l'incident de chute",
			"topHeader": "Enregistré par {{creator}} le {{creationDate}} à {{creationTime}}"
		},
		"linkedObservations": {
			"noLinkedObservations": "Aucune observation liée trouvée.",
			"table": {
				"causedBy": "Cause",
				"consequence": "Conséquence",
				"header": {
					"occurredOn": "Moment de l'événement",
					"type": "Type"
				}
			},
			"title": "Observations liées"
		},
		"resident": {
			"firstName": {
				"label": "Prénom"
			},
			"lastName": {
				"label": "Nom"
			},
			"title": "Résident"
		},
		"restrictiveMeasures": {
			"applicationApproval": {
				"fileNamePrefix": "MRL_akkoord voor toepassing",
				"mainTitle": "Accord pour application"
			},
			"dateLabel": "date",
			"detailsLabel": "Details d'execution",
			"discontinuationApproval": {
				"fileNamePrefix": "MRL_akkoord voor arrêt",
				"mainTitle": "Accord pour arrêt"
			},
			"doctorSignature": {
				"applicationText": "Je soussigné(e), …………………………………….................................................., médecin traitant de ……………………………….........................................................................................., déclare par la présente estimer les mesures susmentionnées nécessaires.",
				"discontinuationText": "Je soussigné(e), …………………………………….................................................., médecin traitant de ……………………………….........................................................................................., déclare par la présente donner mon accord pour la levée des mesures susmentionnées.",
				"title": "Accord du médecin traitant"
			},
			"evaluationDateLabel": "Date de l'évaluation",
			"followUpPlanLabel": "Plan de suivi",
			"header": {
				"createdBy": "Document créé le {{date}} à {{time}} par {{user}}",
				"smallTitle": "Accord médical pour les mesures restrictives de liberté"
			},
			"reasonLabel": "Raison",
			"residentSignature": {
				"applicationText": "Je soussigné(e), ………………………………………................................................................................. déclare par la présente avoir été informé(e) de l'application des mesures susmentionnées concernant ….………………………................................................................................................................................…….. ",
				"discontinuationText": "Je soussigné(e), ………………………………………................................................................................. déclare par la présente avoir été informé(e) de la levée des mesures susmentionnées concernant ………………………................................................................................................................................…….. ",
				"title": "Notification au résident, à la famille ou au représentant légal"
			},
			"signatureLabel": "signature"
		},
		"signature": {
			"label": "Signature du soignant qui a enregistré l'incident de chute"
		}
	}
}
